export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL as string;
export const API_ORIGIN = process.env.REACT_APP_API_BASE_URL ?? "";

export interface AuthUser {
  id: string;
  email: string;
  firstname: string;
  lastname: string;
  role: string;
  isActive: boolean;
  lastLoginAt: string | null;
  username?: string;
  permissions: string[];
  [key: string]: unknown;
}

export const roleRoutes: Record<string, string> = {
  super_admin: "/super-admin",
  admin: "/admin",
  finance: "/accountant",
  customer_service: "/customer-care",
};

export const saveAuth = ({
  token,
  user,
}: {
  token: string;
  user: AuthUser;
}): void => {
  localStorage.setItem("adminToken", token);
  localStorage.setItem("adminUser", JSON.stringify(user));
  localStorage.setItem("adminUserId", (user.id ?? user._id) as string);
};

export const clearAuth = (): void => {
  localStorage.removeItem("adminToken");
  localStorage.removeItem("adminUser");
  localStorage.removeItem("adminUserId");
};

export const getToken = (): string | null =>
  localStorage.getItem("adminToken");

export const getUser = (): AuthUser | null => {
  try {
    const raw = localStorage.getItem("adminUser");
    return raw ? (JSON.parse(raw) as AuthUser) : null;
  } catch {
    return null;
  }
};

export const getDashboardPath = (role: string): string =>
  roleRoutes[role] ?? "/";
